import React, { useEffect } from "react";
import RenderSubCategories from "features/Category/subcategory/components/SubCategories";
import SortContext from "context/SortContext";
import { useLocation } from "react-router-dom";
import { useFilter } from "context/FilterContext";

const SubCategories = () => {
  const location = useLocation();

  const { setSortOptions, setSelectedSortValue, setSearch, search, selectedSortValue, sortOptions } = React.useContext(SortContext);
  const { setFilterCount } = useFilter();

  React.useEffect(() => {
    setSearch("");
    setSortOptions([
      { id: 1, name: "Alphabetical Quote (A to Z)", sortBy: "alphabetical", order: "asc" },
      { id: 2, name: "Alphabetical Quote (Z to A)", sortBy: "alphabetical", order: "desc" },
      { id: 3, name: "Design Quantity (High to Low)", sortBy: "quantity", order: "desc" },
      { id: 4, name: "Design Quantity (Low to High)", sortBy: "quantity", order: "asc" },
    ]);
    setFilterCount(0);
    sessionStorage.setItem("filterChangeCount", 0);
    return () => {
      setSortOptions([]);
      setSelectedSortValue(null);
      setSearch("");
      sessionStorage.removeItem("appliedSortValue");
    };
  }, []);

  useEffect(() => {
    sessionStorage.setItem("appliedSortValue", selectedSortValue);
  }, [selectedSortValue, sortOptions]);

  useEffect(() => {
    setSearch(location?.state?.subCatgeorySearch || "");
  }, [location]);

  return <RenderSubCategories />;
};

export default SubCategories;
